import IFooterProps from "@/interfaces/Props/@extended/IFooterProps";
import { Box, Button } from "@mui/material";
import Label from "../Label/Label";
import { useAppSelector } from "@/redux/hooks";
import { selectProject } from "@/redux/features/Service/serviceSlice";
import { steps } from "@/containers/pages/General/Stepper";

const Footer = (props: IFooterProps) => {
  const {
    disabledNext = false,
    disabledBack = false,
    hideNext,
    hideBack,
    onBackClick,
    onNextClick,
  } = props;

  const service = useAppSelector(selectProject);


  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        {
          !hideBack && <Button
            disabled={disabledBack || service.activeStep === 0}
            onClick={onBackClick}
            variant="contained"
            sx={{
              mr: 1,
            }}
          >
            {
              <Label id="btn_back" />
            }

          </Button>
        }

        <Box sx={{ flex: "1 1 auto" }} />
        {
          !hideNext && <Button
            onClick={onNextClick}
            variant="contained"
            disabled={disabledNext}
          >
            {service.activeStep === steps.length - 1 ? (
              <Label id="btn_finished" />
            ) : (
              <Label id="btn_next" />
            )}
          </Button>
        }

      </Box>
    </>
  )
};

export default Footer;
